import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

const routes: Routes = [
    {
        path: 'forgot-password',
        redirectTo: '/home/forgot-password'
    },
    {
        path: 'reset-password',
        redirectTo: '/home/reset-password'
    },
    {
        path: 'login',
        redirectTo: '/home/login'
    },
    {
        path: 'eeo-detail/:consultantId',
        redirectTo: '/home/eeo-detail/:consultantId'
    },
    {
        path: 'home',
        loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
    },
    {
        path: '**',
        redirectTo: '/home/login'
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
